<script setup lang="ts">
definePage({
  meta: {
    id: 'prsm',
    title: 'Prisme',
    icon: 'mdi-bacteria-outline',
    drawerIndex: 7,
    breadcrumb: 'disabled',
    requiresAuth: true,
    requiresSiteAccess: 'prisme.base'
  },
})
</script>
<template>
  <RouterWrapper />
</template>
